import React from 'react';
import { Button } from 'antd';
import { Icon } from '@common/components';

export const CurrencyRangeFilterButton = ({
  keyName,
  rangeArray,
  clearFilter,
}: {
  keyName: string;
  rangeArray: [string, string];
  clearFilter: (value: string) => void;
}) => (
  <Button onClick={() => clearFilter(keyName)}>
    <Icon icon="xMark" kind="light" />
    {`$${rangeArray[0]} - $${rangeArray[1]}`}
  </Button>
);
